import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import {
  Router,
  ActivatedRoute,
  Params
} from "@angular/router";

@Injectable()

export class NavbarService {

  constructor(private _http: HttpClient) { }

  

  public requestData(arr_dev, apiToken: string): Observable<any[]> {
  
    let api_string = "https://api.cognition.world/v1/quality/weather/external/dash/";
    let arr_api =[];
    
    for (let a of arr_dev) {
      let response;
      response = this._http.get(api_string+a, {headers:{'Authorization': apiToken}});
      ////console.log(response,"response")
      arr_api.push(response);
    }
    ////console.log("arr_api",arr_api)
    return Observable.forkJoin(arr_api);
  }

  public requestDegreeDays(_deveui, apiToken){
    // let _deveui = "kwe1_dd"
    // let urlToCall = "https://hbf6tf3lqa.execute-api.eu-west-1.amazonaws.com/dev/degreedays/"+_deveui
    let urlToCall = "https://api.cognition.world/v1/sustainability/degreedays/external/dash/"+_deveui
    return this._http.get(urlToCall,{headers:{'Authorization': apiToken}})
  }
  
}



// WEBPACK FOOTER //
// ./src/app/shared/navbar/navbar.service.ts